// The two-factor handshake has to survive the tab being discarded while the
// user swaps to their authenticator app, which mobile browsers do readily.
// Only the opaque tmpAuthToken and the email are kept: the QR code and the
// secret encode the long-lived TOTP seed and are never written to storage.
const STORAGE_KEY = 'solomon-2fa-handshake';

export interface TwoFactorHandshake {
  tmpAuthToken: string;
  email: string;
}

export function readHandshake(): TwoFactorHandshake | undefined {
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);

    if (!raw) {
      return undefined;
    }

    const saved = JSON.parse(raw) as Partial<TwoFactorHandshake>;

    // Both halves are needed. Step two sends the email so the API's active-user
    // check can find the collaborator, so a handshake without one would strand
    // the user on the code screen with no request that can ever succeed.
    if (!saved?.tmpAuthToken || !saved?.email) {
      return undefined;
    }

    return { tmpAuthToken: saved.tmpAuthToken, email: saved.email };
  } catch {
    // Storage unavailable or the entry is malformed - start afresh.
    return undefined;
  }
}

export function saveHandshake({ tmpAuthToken, email }: TwoFactorHandshake) {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ tmpAuthToken, email }));
  } catch {
    // Storage unavailable - the handshake just will not survive a tab discard.
  }
}

export function clearHandshake() {
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Storage unavailable - there is nothing to clear.
  }
}
